/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import Modal, { ModalHeader } from '../../../components/Modal'
import { CONDITION_TYPE } from '../../../constants/TAG'
import useForm from '../../../hooks/useForm'
import Form from "../../../components/Form";
import TagBankTransModal from './TagClientComponent/TagBankTransModal';
import TagClientModal from './TagClientComponent/TagClientModal';
import { createBankTransMappingTags } from '../../../apis/finances/bank';
import { isEmpty, isNull } from 'lodash';
import IconButton from '../../../components/Button/IconButton';
import DeleteButton from "../../../assets/images/icon/delete-icon-01.svg";
import systemAlert from '../../../utils/systemAlert';


const TagClientMapping = ({ open, setOpen, submit }) => {
  const [fields, setFields] = useState([])
  // 은행입출금
  const [bankTransOpen, setBankTransOpen] = useState(false)
  // 거래처
  const [clientOpen, setClientOpen] = useState(false)

  const defaultForm = {
    bankTransIdx: null,
    traderNameText: "",
    traderNameCondition: "complete_match",
    remarkText: "",
    remarkCondition: "complete_match",
    detailText: "",
    detailCondition: "complete_match",
    sendBankAccountHolderText: "",
    sendBankAccountHolderCondition: "complete_match",
    applyToOtherBankTrans: false,
    clientIdx: null,
    clientName: ''
  }

  const cancel = () => {
    setOpen(false)
  }

  const _submit = (form) => {
    const body = {
      bankTransIdx: form.bankTransIdx || undefined,
      traderNameText: form.traderNameText,
      traderNameCondition: form.traderNameCondition,
      remarkText: form.remarkText,
      remarkCondition: form.remarkCondition,
      detailText: form.detailText,
      detailCondition: form.detailCondition,
      sendBankAccountHolderText: form.sendBankAccountHolderText,
      sendBankAccountHolderCondition: form.sendBankAccountHolderCondition,
      applyToOtherBankTrans: form.applyToOtherBankTrans,
    }

    systemAlert('매핑 항목을 추가하시겠습니까?', {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '추가',
          onClick: () => {
            createBankTransMappingTags(form.clientIdx, body)
              .then(() => {
                submit()
                cancel()
              })
              .catch(() => { })
          }
        }
      ]
    })
  }

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setForm,
    setOriginForm,
  } = useForm(
    defaultForm,
    _submit
  );

  useEffect(() => {
    setForm(defaultForm)
    setOriginForm(defaultForm)
  }, [open])

  useEffect(() => {
    setFields([
      {
        title: '은행내역',
        key: 'bankTransIdx',
        type: 'button',
        label: '은행내역 불러오기',
        action: () => setBankTransOpen(true)
      },
      [
        {
          title: '거래자명',
          key: 'traderNameText',
          type: 'input'
        },
        {
          key: 'traderNameCondition',
          type: 'radio',
          options: {
            list: CONDITION_TYPE,
          },
        }
      ],
      [
        {
          title: '입금자',
          key: 'sendBankAccountHolderText',
          type: 'input'
        },
        {
          key: 'sendBankAccountHolderCondition',
          type: 'radio',
          options: {
            list: CONDITION_TYPE,
          },
        }
      ],
      [
        {
          title: '적요',
          key: 'remarkText',
          type: 'input'
        },
        {
          key: 'remarkCondition',
          type: 'radio',
          options: {
            list: CONDITION_TYPE,
          },
        }
      ],
      [
        {
          title: '적요(상세)',
          key: 'detailText',
          type: 'input'
        },
        {
          key: 'detailCondition',
          type: 'radio',
          options: {
            list: CONDITION_TYPE,
          },
        }
      ],
      [
        {
          title: '거래처',
          key: 'client',
          type: 'button',
          label: '거래처 불러오기',
          action: () => setClientOpen(true),
          required: true,
        },
        {
          key: 'clientName',
          onValue: (value) => {
            return (
              !isEmpty(value) && (
                <>
                  {value}
                  <IconButton className="ml-8" icon={DeleteButton} action={() => {
                    setForm({
                      ...form,
                      clientIdx: null,
                      clientName: ""
                    })
                  }} />
                </>
              )
            )
          }
        }
      ],
      {
        title: '과거 항목 적용',
        key: 'applyToOtherBankTrans',
        type: 'checkbox',
        checked: form.applyToOtherBankTrans,
        onChange: (check) => {
          setForm({
            ...form,
            applyToOtherBankTrans: check
          })
        }
      }
    ])
  }, [form])

  return (
    <>
      {!bankTransOpen && !clientOpen &&
        <Modal isOpen={open} close={cancel}>
          <div className="tag-client-mapping-modal">
            <ModalHeader>적요 거래처 매핑 항목 추가</ModalHeader>
            <Form
              form={form}
              errors={errors}
              isRequiredShow={true}
              setForm={setForm}
              fields={fields}
              onChange={handleOnChange}
              submitText={'작성완료'}
              submit={handleSubmit}
              cancel={cancel}
              isDisabledSubmit={isNull(form.clientIdx)}
            />
          </div>
        </Modal>
      }
      {bankTransOpen && <TagBankTransModal open={bankTransOpen} setOpen={setBankTransOpen} tagForm={form} setTagForm={setForm} />}
      {clientOpen && <TagClientModal open={clientOpen} setOpen={setClientOpen} tagForm={form} setTagForm={setForm} />}
    </>
  )
}

export default TagClientMapping